import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { clsx } from 'clsx';
import { INTEL_STAT_TONE_CLASSES, type IntelStatTone } from './intelVisualConfig';

type Props = {
    icon: LucideIcon;
    tone?: IntelStatTone;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
};

const SIZE_CLASSES = {
    sm: { wrap: 'p-1.5', icon: 'h-3.5 w-3.5' },
    md: { wrap: 'p-2', icon: 'h-4 w-4' },
    lg: { wrap: 'p-2.5', icon: 'h-6 w-6' },
};

export const IntelStatIcon: React.FC<Props> = ({ icon: Icon, tone = 'neutral', size = 'sm', className }) => {
    const dim = SIZE_CLASSES[size];
    return (
        <span
            className={clsx(
                'inline-flex shrink-0 items-center justify-center rounded-lg',
                dim.wrap,
                INTEL_STAT_TONE_CLASSES[tone],
                className,
            )}
            aria-hidden
        >
            <Icon className={dim.icon} strokeWidth={2.25} aria-hidden />
        </span>
    );
};
